import React from "react"; 
import CargoShipmentReportListPageContainer from "./CargoShipmentReportListPageContainer";

 export class CargoShipmentReportListPage extends React.Component {
  render() {
    return <CargoShipmentReportListPageContainer {...this.props} />;
  }
}
